export const FILE_STATE = {
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  UPLOAD_ERROR: 'upload_error',
  DELETING: 'deleting',
  DELETE_ERROR: 'delete_error',
};
